/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule, LazyloadService } from '@dm/core';

import { BatchConfigModule } from './batch-config/batch-config.module';
import { ExportModule } from './export/export.module';
import { HeaderSettingsComponent } from './header-settings.component';
import { RestartShutdownModule } from './restart-shutdown/restart-shutdown.module';
import { SystemInfoModule } from './system-info/system-info.module';
import { SystemUpgradeModule } from './upgrade/system-upgrade-panel/system-upgrade.modules';
import { UpgradeChooseModeModule } from './upgrade/upgrade-choose-mode/upgrade-choose-mode.module';
import { UpgradeModule } from './upgrade/upgrade-panel/upgrade.modules';
import { UpgradeUploadEntryModule } from './upgrade/upload-entry/upgrade-upload-entry.modules';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        ExportModule,
        RestartShutdownModule,
        SystemInfoModule,
        BatchConfigModule,
        UpgradeUploadEntryModule,
        UpgradeModule,
        SystemUpgradeModule,
        UpgradeChooseModeModule,
    ],
    exports: [
        HeaderSettingsComponent,
    ],
    declarations: [
        HeaderSettingsComponent,
    ],
    providers: [LazyloadService],
})
export class HeaderSettingsModule { }
